import { render } from "./ImageCarousel2.vue?vue&type=template&id=252c3c99&scoped=true"
import script from "./ImageCarousel2.vue?vue&type=script&lang=js"
export * from "./ImageCarousel2.vue?vue&type=script&lang=js"

import "./ImageCarousel2.vue?vue&type=style&index=0&id=252c3c99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252c3c99"]])

export default __exports__